<template>
  <v-card flat tile style="padding: 0px 40px 20px;">
    <div class="d-flex flex-column align-center">
      <v-system-bar color="cyan darken-2" dark style="height: 50px">
          <v-card-title>
            {{savedNodes.length}} Saved Node<span v-if="savedNodes.length>1">s</span>
          </v-card-title>
      </v-system-bar>
      <span v-if="savedNodes.length>0">
        <div class="pt-4">
          <p>Press a node to add it to your canvas</p>
        </div>
      </span>
      <span v-if="savedNodes.length===0">
        <div class="pt-4">
          <p>[ No Saved Node ]</p>
        </div>
      </span>
    </div>
    
    <v-divider class="mx-4"></v-divider>

    <v-container class="white" fluid >
      <v-row>
        <v-spacer></v-spacer>
        <v-col
          v-for="node in savedNodes"
          :key="node._id"
          cols="10"
          sm="9"
          md="3"
        >
          <a @click="createNodeFromTemplate(node)" title="Click to add node to canvas">
            <v-hover v-slot="{ hover }">
              <v-card :class="{ 'on-hover': hover }" :elevation="hover ? 12 : 2" class="new-font">
                  <SavedNode :onActions="node.actions" :onNamenode="node.name" :onAnchors="node.anchors"/>
              </v-card>
            </v-hover>
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>

import Node from "./Node";
import SavedNode from "./SavedNode.vue";
import { mapActions } from "vuex";


export default {
  components: {
    Node,
    SavedNode
  },
  props:{
    onX: Number,
    onY: Number,
    onSavedNodes: Array
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions({
      createNode: "http/nodes/createNode",
      addNodeToCanvas: "canvas/addNode",
      addAction: 'http/nodes/addAction',
      updateNode: 'http/nodes/updateNode',
      getNode: 'http/nodes/getNode',
      createAnchor: 'http/anchors/createAnchor',
      getNodes: 'http/nodes/getNodes',
      getSavedNodes: "http/nodes/getSavedNodes",
      addSavedNodeToTemplate: "canvas/addSavedNode",
      getSkills: "http/skills/get",
    }),
    async createNodeFromTemplate(node){
      this.$confirm(`Are you sure you want to add this node to canvas?`).then(async res => {
        if (res) {
          const newNodeData = {
            position: {
              x: this.onX,
              y: this.onY
            }
          };
          const newNode = await this.createNode({
            skillId: this.$route.params.skillId,
            data: newNodeData,
          });
          // Add a name to new node
          await this.updateNode({
            skillId: this.$route.params.skillId,
            idNode: newNode._id,
            data: {name: "new node"}
          })
          // Add actions to new node
          for (let i=0; i<node.actions.length; i++) {
            const oldAction = node.actions[i];
            const newAction = {
              name: oldAction.name,
              args: oldAction.args, 
              actionType: oldAction.actionType
            };
            await this.addAction({
              skillId: this.$route.params.skillId,
              idNode: newNode._id,
              action: { action: newAction }
            });
          }
          // Add anchors to new node
          for (let i=0; i<node.anchors.length; i++) {
            const oldAnchor = node.anchors[i];
            if (oldAnchor.name !== 'in' && oldAnchor.name !== 'default' ){
              const newAnchor = {
                name: oldAnchor.name,
                in: false,
                out: true,
                variable: oldAnchor.variable,
                value: oldAnchor.value,
              };
              await this.createAnchor({
                skillId: this.$route.params.skillId,
                id: newNode._id,
                data: newAnchor,
              }).then(anchor => {
                newNode.anchors.push(anchor);
              })
            }
          } 
          // Add the new node to canvas
          await this.getNode({
            skillId: this.$route.params.skillId,
            idNode: newNode._id
          }).then((data) => { 
            this.addNodeToCanvas(data);
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

  },
  computed: {
    nodes: {
      get() {
        return this.$store.state.canvas.nodes;
      }
    },
    savedNodes: {
      get() {
        return this.$store.state.canvas.savedNodes;
      }
    }
  }, 
  mounted() {
    // To re see next time with savecNodes from store
    this.getSkills({projectId: this.$route.params.id})
      .then((project) => {
        project.map((skill) => {
          this.getSavedNodes(skill._id)
            .then((savedNodes) => {
              const promises = savedNodes.map((savedNode) => this.addSavedNodeToTemplate(savedNode));
              return Promise.all(promises);
            })
            .catch((err) => {
              console.log(err.message);
            })
        });
      })
      .catch((err) => {
          console.log(err.message);
      });
  },
}
</script>

<style lang="scss" scoped>

.new-font{
  font-size: 13px;
  font-family: Arial, Helvetica, sans-serif;
}

</style>